<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card grid-list-md>
      <ModelTitle title="New Donor" @close="close()" />

      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field :error-messages="nameErrors" autofocus v-model="donor.name" :background-color="`${donor.name ? false : $style.inputBox.mandatory
              }`" label="Name" @change="donor.name = properCase(donor.name)" :hide-details="nameErrors.length === 0"
              outlined @focus="$event.target.select()" dense></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field outlined hide-details dense v-mask="'(###) ###-####'" @focus="$event.target.select()"
              v-model="donor.phoneNumber" label="Phone Number"></v-text-field>
          </v-col>

          <v-col cols="6">
            <v-text-field outlined hide-details dense v-model="donor.email" label="Email Address"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12">
            <v-text-field outlined hide-details dense v-model="donor.address" label="Address"></v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="4">
            <v-text-field outlined hide-details dense @change="donor.city = properCase(donor.city)" v-model="donor.city"
              label="City"></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field outlined dense v-mask="'AA'" hide-details v-model="donor.state" label="State"></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field outlined hide-details dense v-mask="'#####'" v-model="donor.zip" label="Zip Code">
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="12">
            <v-textarea outlined hide-details dense auto-grow v-model="donor.note" :label="$t('labels.note')">
            </v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <span class="mr-2">Active</span>
        <toggle-button :width="60" :labels="{ checked: 'Show', unchecked: 'Hide' }" v-model="donor.isActive"
          :value="donor.isActive" :sync="true">
        </toggle-button>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <v-btn color="primary" :loading="loading" dark @click="submit()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import donorService from "@/modules/Donors/service.js";
import GlobalFunction from "@/mixins/GlobalFunction";

const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");

export default {
  props: {
    createDialog: {
      default: false,
    },
    createFromStore: {
      type: Boolean,
    },
  },
  name: "create-donor",
  data() {
    return {
      foundError: false,
      loading: false,
      dialog: false,
      donor: {
        isActive: true,
        name: null,
        phoneNumber: null,
        emailAddress: null,
        address: null,
        city: null,
        state: null,
        zip: null,
        note: null,
      },
    };
  },
  mixins: [validationMixin, GlobalFunction],
  validations: {
    donor: {
      name: {
        required,
      },
    },
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    nameErrors() {
      const errors = [];
      if (!this.$v.donor.name.$dirty) return errors;
      if (!this.$v.donor.name.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
  },
  watch: {
    createDialog(val) {
      this.dialog = val;
    },
  },
  methods: {
    // properCase(string) {
    //   var sentence = string.toLowerCase().split(" ");
    //   for (var i = 0; i < sentence.length; i++) {
    //     sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
    //   }
    //   return sentence.join(" ");
    // },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.donor = {
        isActive: true,
        name: null,
        phoneNumber: null,
        emailAddress: null,
        address: null,
        city: null,
        state: null,
        zip: null,
        note: null,
      };
      this.$v.$reset();
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.loading = true;
        if (this.donor.phoneNumber) {
          this.donor.phoneNumber = this.donor.phoneNumber.replace(
            /[^a-zA-Z0-9]/g,
            ""
          );
        }
        return donorService
          .create(this.donor)
          .then((result) => {
            if (result.status == 409) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "error",
                  title: result.data.message,
                });
                this.loading = false;
                return false
            }
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "success",
                title: "Donor is created",
              });
            this.loading = false;
            this.$emit("submit");
            // this.$events.emit("customerListEvent");
            this.close();
          })
          .catch((err) => {
            console.log("err", err);
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
            this.close();
          });
      }
    },
  },
};
</script>

<style scoped></style>
